<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">

            <el-form-item slot="title">
                <el-input
                v-model="pgData.txtKey3"
                placeholder="招标项目/标段名称"
                :disabled="dataload"
                clearable></el-input>
            </el-form-item>

            <el-form-item slot="time">
<!--                <el-radio-group v-model="pgData.issh" @change="searchHandler" :disabled="dataload">-->
<!--                    <el-radio-button label="1">未截止报名</el-radio-button>-->
<!--                    <el-radio-button label="0">已截止报名</el-radio-button>-->
<!--                </el-radio-group>
                <el-select v-model="pgData.issh" placeholder="报名情况"  @change="searchHandler" :disabled="dataload" clearable>
                    <el-option
                            key="1"
                            label="未截止"
                            value="1">
                    </el-option>
                    <el-option
                            key="0"
                            label="已截止"
                            value="0">
                    </el-option>
                </el-select>-->
            </el-form-item>

            <!-- <el-form-item>
                <el-radio-group v-model="pgData.issf" @change="searchHandler">
                    <el-radio-button label="0">不收取标段费</el-radio-button>
                    <el-radio-button label="1">收标段费</el-radio-button>
                </el-radio-group>
            </el-form-item> -->
            
        </my-search>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="项目信息" prop="zbprocode" sortable min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        {{scope.row.zbproname}}
                    </div>
                    <div class="table-info-row">
                        {{scope.row.zbprocode}}
                    </div>
                </template>
            </el-table-column>

            <el-table-column label="标段信息" prop="bdcode" sortable min-width="220">
                <template slot-scope="scope">
                    <div class="table-info-row">
                        <el-button type="text" @click="bdDetail(scope.row)">
                            {{scope.row.bdname}}
                        </el-button>
                    </div>
                    <div class="table-info-row">
                        {{scope.row.bdcode}}
                    </div>
                </template>
            </el-table-column>
            
            <el-table-column label="标段分类" prop="bdtypename" sortable width="150"></el-table-column>
            <el-table-column label="标段投资概算" prop="bdhtgsj" sortable width="150">
                <template v-slot="scope">
                    {{scope.row.bdhtgsj}}
                    {{scope.row.jedwname}}
                    {{scope.row.bztext}}
                </template>
            </el-table-column>
            
            <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                    <btn-list
                        :row="scope.row" 
                        :config="BTN_CONF"
                    ></btn-list>
                </template>
            </el-table-column>
        </my-table>

        <my-pagination
            ref="page"
            v-model="tableData"
            :search="pgData"
            :before-query="beforeQuery"
            :after-query="afterQuery"
            :action="`${getGetters('mngUrl')}/manage/finance/auditbsk/get_list.json`">
        </my-pagination>

    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import BTN_CONF from './config/btns-list'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: { },
    data() {
        return {
            pgData: {
                sortname: 'addtime',

                issh: '',
                txtKey3: '',
            },

            BTN_CONF,
            dataload:false,
        }
    },
    computed: {
        
    },
    methods: {
        bdDetail(row) {
            this.goto({
                path: '/bidding/projectflow/fangan/biaoduan/detail',
                query: {
                    id: row.bdcode,
                    isZc:'false'
                }
                
            });
        },
        beforeQuery(){
            this.dataload=true;
        },
        afterQuery(){
            this.dataload=false;
        },
    },
    created() {
        // this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditbsk/bdlist.json`, {
            
        // }, data => {
        //     this.jspDataInit(data, [
        //         'dwcode',
        //     ]);
        // });
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    .table-info-row + .table-info-row{margin-top:.5em;}
</style>
